module.exports = __webpack_public_path__ + "static/media/Shekar Murthy.c422fb76.png";